export interface DriverInfo {
  driver: string;
  driver_url: string;
}

export const detectDriver = (jdbcUrl: string): DriverInfo | null => {
  const url = (jdbcUrl || '').toLowerCase();
  if (!url.startsWith('jdbc:')) return null;

  switch (true) {
    case url.includes('postgresql') || url.includes('postgres'):
      return {
        driver: 'org.postgresql.Driver',
        driver_url: 'https://repo1.maven.org/maven2/org/postgresql/postgresql/42.7.3/postgresql-42.7.3.jar'
      };
    case url.includes('mysql'):
      return {
        driver: 'com.mysql.cj.jdbc.Driver',
        driver_url: 'https://repo1.maven.org/maven2/com/mysql/mysql-connector-j/8.3.0/mysql-connector-j-8.3.0.jar'
      };
    case url.includes('mariadb'):
      return {
        driver: 'org.mariadb.jdbc.Driver',
        driver_url: 'https://repo1.maven.org/maven2/org/mariadb/jdbc/mariadb-java-client/3.3.3/mariadb-java-client-3.3.3.jar'
      };
    case url.includes('sqlserver') || url.includes('mssql'):
      return {
        driver: 'com.microsoft.sqlserver.jdbc.SQLServerDriver',
        driver_url: 'https://repo1.maven.org/maven2/com/microsoft/sqlserver/mssql-jdbc/12.8.1.jre11/mssql-jdbc-12.8.1.jre11.jar'
      };
    case url.includes('oracle'):
      return {
        driver: 'oracle.jdbc.OracleDriver',
        driver_url: 'https://repo1.maven.org/maven2/com/oracle/database/jdbc/ojdbc11/23.3.0.23.09/ojdbc11-23.3.0.23.09.jar'
      };
    case url.includes('snowflake'):
      return {
        driver: 'net.snowflake.client.jdbc.SnowflakeDriver',
        driver_url: 'https://repo1.maven.org/maven2/net/snowflake/snowflake-jdbc/3.16.1/snowflake-jdbc-3.16.1.jar'
      };
    case url.includes('sqlite'):
      return {
        driver: 'org.sqlite.JDBC',
        driver_url: 'https://repo1.maven.org/maven2/org/xerial/sqlite-jdbc/3.45.1.0/sqlite-jdbc-3.45.1.0.jar'
      };
    case url.includes('clickhouse'):
      return {
        driver: 'com.clickhouse.jdbc.ClickHouseDriver',
        driver_url: 'https://repo1.maven.org/maven2/com/clickhouse/clickhouse-jdbc/0.6.0/clickhouse-jdbc-0.6.0-all.jar'
      };
    case url.includes('redshift'):
      return {
        driver: 'com.amazon.redshift.jdbc.Driver',
        driver_url: 'https://s3.amazonaws.com/redshift-downloads/drivers/jdbc/2.1.0.30/redshift-jdbc42-2.1.0.30.jar'
      };
    default:
      return null;
  }
};
